import { action, atom } from "@reatom/core"
import { onConnect } from "@reatom/hooks"

import { City } from "utils/interfaces"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { Services } from "modules/PsyCatalog/common/services"
import { citiesSlugsAtom } from "modules/PsyCatalog/common/models/cities/citiesSlugsAtom"
import { citiesFetcher } from "modules/PsyCatalog/common/models/cities/citiesFetcher"

export function cityAtomField({ UpdateUrl, CurrentQuery, CurrentFilter, FieldStatus }: Services) {
    const inputValue = atom<City | undefined>(undefined)
    const update = action((ctx, city: City | undefined) => {
        inputValue(ctx, city)
    })

    function onChange(city: City | undefined) {
        update(ctx, city)
        UpdateUrl.run()
    }

    function parseAndUpdate(value: unknown) {
        const cities = ctx.get(citiesFetcher.dataAtom)
        update(
            ctx,
            cities.find((c) => c.name === value)
        )
    }

    onConnect(inputValue, () => {
        const initialValue = CurrentQuery.get().city
        ctx.subscribe(citiesSlugsAtom, (slugs) => {
            if (slugs.size === 0) return
            const urlFilter = CurrentFilter.get()
            const name = urlFilter ? slugs.get(urlFilter)?.value : initialValue
            parseAndUpdate(name)
            FieldStatus.setReady("city")
        })
    })
    return { inputValue, onChange, parseAndUpdate }
}
